<template>
    <div class="page company" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中">
        <div class="gray"></div>
        <div class="header pw fix">
            <div class="clogo fl">
                <el-image :src="cLogo" style="width: 100%;height: 100%">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="el-image__error">
                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                    </div>
                </el-image>
            </div>
            <div class="csearch fr header_r">
                <search></search>
            </div>
        </div>
        <div class="nav pw fix">
            <comNav @tabNavClick="tabNavClick"></comNav>
        </div>
        <!-- <div class="black" v-if="navTab!='1'"></div> -->
        <div class="pw">
            <router-view :id="organId"></router-view>
        </div>
        <comFooter :comName="comName"></comFooter>
    </div>
</template>

<script>
import search from "./components/search";
import comNav from "./components/comNav";
// import cpnHome from "./views/home";
import comFooter from "./components/comFooter";
import { postDetail } from '@/api/company'
// import { mapActions, mapGetters } from "vuex";

export default {
    name: "auctionCompany",
    data(){
        return{
            isLoading:true,
            cLogo: "",
            navTab:'2',
            comName:'中国嘉德',
            organId:''
        }
    },
    // computed:{
    //     ...mapGetters({
    //         getIsLoadIng: "pageOrgMeta/getIsLoadIng",
    //         getData: "pageOrgMeta/getData",
    //     }),
    // },
    //服务端渲染
    // asyncData({ store,route }) {
    //     let params = {
    //         zone_name:route.params.name
    //     }
    //     return store.dispatch("pageOrgMeta/setOrgMeta", params);
    // },
    mounted() {
        const webName = this.$route.params.name;
        this.postDetail(webName);
        // setTimeout(()=>{
        //     this.isLoading=false;
        //     this.cLogo="https://img5.artron.net/auction_manager/auction_zone_5/JG0005/2021123011003995363.png"
        // },1000);
        // this.$store.dispatch('pageCompany/getCompanyList')
        // if (!this.getIsLoadIng){
        //     let parmas = {
        //         zone_name:webName
        //     }
        //     this.setOrgMeta([parmas,()=>{
        //         this.filteData();
        //     }])
        // }else{
        //     this.filteData();
        // }
    },
    methods:{
        // ...mapActions({
        //     setOrgMeta:"pageOrgMeta/setOrgMeta"
        // }),
        filteData(){
            let data = this.$store.state["pageOrgMeta"]["data"]
            document.title = data.meta ? data.meta.title :'';
            let head = document.getElementsByTagName('head');
            this.isLoading = false
            if(!document.querySelector('meta[name=description]')){
                let meta = document.createElement('meta');
                meta.name = 'description';
                meta.content = data.meta ? data.meta.description : '';
                head[0].appendChild(meta)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
            }
        },
        tabNavClick(nav,item){
            this.navTab=nav;
            let pathName = item.pathName;
            this.$router.push({
                name:pathName
            })
        },
        postDetail(name) {
            postDetail({
                web_name: name
            }).then(res => {
                this.isLoading=false;
                this.cLogo = res.data.logo
                this.organId = res.data.organ_id
                // this.$set(this.id,res.data.organ_id)
            })
        }
    },

    components:{
        search,
        comNav,
        comFooter,
    }
}
</script>
<style lang="scss">
.company{
.pw{width:980px !important;margin:0 auto;}
    .w780{width:680px !important;}
    .w380{width:280px !important;}
}
</style>

<style scoped lang="scss">
@import url(../../assets/css/reset.css);
.company{
    min-width: 1180px;
    

    .gray{
        background: #e6e6e6;
        height: 10px;
        width: 100%;
        overflow: hidden;
    }
    .header{
        margin-top: 40px;
    }
    .header_r{
        margin-top: 13px;
    }
    .nav{
        margin-top: 45px;
    }
    .clogo{
        height: 55px;
        width: 270px;
        /deep/.el-image__inner{
            object-fit: contain;
        }
    }
    .black{
        background: #000;
        height: 20px;
        margin-top: 15px;
        margin-bottom: 40px;
    }

}
</style>